export const REMINDER_DEFAULTS = {
  reminderCount: 0,
  reminderDelayMinutes: 30,
  reminderText: 'Un questionnaire est en attente de votre réponse',
} as const;
